import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useState } from "react";
import { IoMdEyeOff } from "react-icons/io";
import { IoEye } from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { loginUser } from "../../../service/AuthService";

const LoginForm = ({ onFormChange }) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const handleLogin = async (values, setSubmitting, setErrors) => {
    setIsLoading(true);
    try {
      const data = await loginUser(values);

      if (data.header.code === 600) {
        localStorage.setItem('accessToken', data.body.value.accessToken);
        localStorage.setItem('name', data.body.value.name);
        localStorage.setItem('email', data.body.value.email);
        localStorage.setItem('role', data.body.value.role);
        localStorage.setItem('profilePicture', data.body.value.profilePicture);
        localStorage.setItem('userId', data.body.value.userId);
        localStorage.setItem('occupation', data.body.value.occupation);
        navigate('/')

        setIsLoading(false);
      } else {
        if (data.body.error.toLowerCase().includes('email')) {
          setErrors({ email: data.body.error });
        } else if (data.body.error.toLowerCase().includes('password')) {
          setErrors({ password: data.body.error });
        }
        setIsLoading(false);
      }
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setSubmitting(false);
    }
  };


  const handleForgotPasswordClick = () => {
    onFormChange("forgotPassword");
  };

  return (
    <>
      <div className="my-auto mx-auto flex flex-col justify-center px-6 pt-8 md:justify-start lg:w-[28rem]">
        <p className="text-center text-3xl font-bold md:text-left md:leading-tight">
          Welcome to Balarch
        </p>
        <p className="mt-2 text-center font-medium md:text-left">
          Don't have an account?
          <Link
            to="/register"
            className="whitespace-nowrap font-semibold text-blue-700 ml-2"
          >
            Sign up
          </Link>
        </p>

        <Formik
          initialValues={{ email: "", password: "" }}
          validationSchema={Yup.object({
            email: Yup.string()
              .email('Invalid email address')
              .required('Required'),
            password: Yup.string()
              .min(6, 'Password must be at least 6 characters')
              .required('Required'),
          })}
          onSubmit={(values, { setSubmitting, setErrors }) => {
            handleLogin(values, setSubmitting, setErrors);
          }}
        >
          {({ isSubmitting, isValid, values }) => (
            <Form>
              <div className="flex flex-col pt-6">
                <div className="relative flex flex-col overflow-hidden rounded-md">
                  <Field
                    type="email"
                    name="email"
                    placeholder="Email"
                    className="w-full py-3 px-4 text-sm text-gray-900 placeholder-gray-400 border-2 border-gray-200 focus:border-purple-500 focus:outline-purple rounded-lg"
                  />
                  <ErrorMessage
                    name="email"
                    component="div"
                    className="text-red-500 text-xs mt-1 m1-2"
                  />
                </div>
              </div>
              <div className="mb-4 flex flex-col pt-4 relative">
                <div className="relative flex flex-col overflow-hidden rounded-md">
                  <Field
                    type={showPassword ? "text" : "password"}
                    name="password"
                    placeholder="Password"
                    className="w-full py-3 px-4 text-sm text-gray-900 placeholder-gray-400 border-2 border-gray-200 focus:border-purple-500 focus:outline-purple rounded-lg"
                  />
                  <button
                    type="button"
                    className="absolute inset-y-0 right-0 flex items-center pr-3 cursor-pointer"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <IoEye /> : <IoMdEyeOff />}
                  </button>
                  <ErrorMessage
                    name="password"
                    component="div"
                    className="text-red-500 text-xs mt-1 ml-2"
                  />
                </div>
              </div>

              <div className="flex justify-end">
                <button
                  type="submit"
                  disabled={!isValid || isSubmitting || !(values.email && values.password)}
                  className={`mt-6 rounded-lg px-4 py-2 text-center text-base font-medium text-white shadow-md outline-none transition ${!isValid || isSubmitting || !(values.email && values.password) ? 'bg-gray-400 cursor-not-allowed' : 'bg-gray-800 hover:bg-gray-900 focus:ring-2 ring-gray-500 ring-offset-2'
                    } md:w-32`}
                >
                  {isLoading ? "processing..." : "Log In"}
                </button>
              </div>
            </Form>
          )}
        </Formik>
        <Link
          className="flex justify-center mt-10 font-semibold text-blue-700"
          onClick={handleForgotPasswordClick}
        >
          Forgot your password?
        </Link>
      </div>
    </>
  );
};

export default LoginForm;
